var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown ts-filter-dropdown",class:{ 'selected' : _vm.model == 1 },staticStyle:{"margin-left":"15px"}},[_c('button',{staticClass:"btn btn-sm dropdown-toggle",attrs:{"type":"button"},on:{"click":function($event){_vm.model = (_vm.model == 1) ? 0 : 1}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }